"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAnyContactInformation = exports.hasAnyAboutInformation = exports.hasAnySocialMedia = void 0;
function hasAnySocialMedia(companyInformation) {
    return Boolean(companyInformation.facebook ||
        companyInformation.instagram ||
        companyInformation.linkedin ||
        companyInformation.pinterest ||
        companyInformation.tiktok ||
        companyInformation.twitter ||
        companyInformation.youtube);
}
exports.hasAnySocialMedia = hasAnySocialMedia;
function hasAnyAboutInformation(companyInformation) {
    return Boolean(companyInformation.about ||
        companyInformation.website ||
        hasAnySocialMedia(companyInformation));
}
exports.hasAnyAboutInformation = hasAnyAboutInformation;
function hasAnyContactInformation(companyInformation) {
    return Boolean(companyInformation.address ||
        companyInformation.phone ||
        companyInformation.email ||
        companyInformation.website);
}
exports.hasAnyContactInformation = hasAnyContactInformation;
//# sourceMappingURL=boilerplate.js.map